import { Asset } from "../../../../models/Asset";
import { AssetParameters } from "../models/AssetParameters";

export const TransformAssetModelData = (node: Asset): AssetParameters => {
	const model: AssetParameters = {
		id: node.AssetId,
		parent: node.ParentAssetId ? node.ParentAssetId : 0,
		text: node.AssetName,
		data: {
			fileType: "csv",
			fileSize: "",
		},
		droppable: node.IsBranch,
	};
	return model;
};
